import React from 'react';
import { Activity, Zap, Shield, MessageCircle } from 'lucide-react';

const StatusBar = () => {
  const statusItems = [
    {
      icon: Activity,
      label: 'Status',
      value: 'Erreichbar',
      color: '#0891B2'
    },
    {
      icon: Zap,
      label: 'Service',
      value: 'Schnell möglich',
      color: '#0891B2'
    },
    {
      icon: Shield,
      label: 'Gutachten',
      value: 'Rechtssicher',
      color: '#0891B2'
    },
    {
      icon: MessageCircle,
      label: 'Kontakt',
      value: 'WhatsApp & Telefon',
      color: '#0891B2'
    }
  ];

  return (
    <div className="container mx-auto px-4" style={{ maxWidth: '1200px', marginTop: '-60px', position: 'relative', zIndex: 10 }}>
      <div className="glass-card" style={{
        background: '#FFFFFF',
        border: '1px solid #E2E8F0',
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
        padding: '32px'
      }}>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {statusItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px',
                  animation: `fade-in-up 0.6s ease-out ${index * 0.1}s both`
                }}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px'
                }}>
                  {/* Pulsing LED */}
                  <div style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    background: item.color,
                    boxShadow: `0 0 12px ${item.color}`,
                    animation: 'pulse-glow 2s ease-in-out infinite',
                    flexShrink: 0
                  }} />
                  
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <Icon size={16} style={{ color: '#718096' }} />
                    <span style={{
                      fontSize: '12px',
                      color: '#718096',
                      fontWeight: '500',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}>
                      {item.label}
                    </span>
                  </div>
                </div>
                
                <div style={{
                  fontSize: '16px',
                  color: '#1a202c',
                  fontWeight: '600',
                  lineHeight: '1.3'
                }}>
                  {item.value}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StatusBar;